"use client";

import React, { FC } from "react";
import Link from "next/link";
import { List } from "react-bootstrap-icons";

const MobileNav: FC = () => {
  return (
    <div className="dropdown dropdown-end">
      <div
        tabIndex={0}
        role="button"
        className="btn hover:text-highlight bg-transparent border-none shadow-none cursor-pointer p-4 pb-5 text-xl"
      >
        <List />
      </div>
      <ul
        tabIndex={0}
        className="dropdown-content menu bg-base-100 rounded-box z-1 w-52 p-2 shadow-sm"
      >
        <li>
          <Link href="/about" className="relative font-normal">
            About
          </Link>
        </li>
        <li>
          <Link href="/projects" className="relative font-normal">
            Projects
          </Link>
        </li>
        <li>
          <Link href="/demos" className="relative font-normal">
            Demos
          </Link>
        </li>
        <li>
          <Link href="/resume" className="relative font-normal">
            Resume
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default MobileNav;
